import React, { useEffect, useState } from 'react';
import VideoPlayer from '../VideoPlayer/VideoPlayer';
import Navbar from '../Navbar/Navbar';
// import {TheosPlayer} from "@aka_theos/react-hls-player";
import { motion } from 'framer-motion';

const VideoSection = ({ module }) => {
  
  
  const [videoUrl, setVideoUrl] = useState("");
  // const [videoUrl, setVideoUrl] = useState(module?.gumletid);

  useEffect(() => {
    
    // if (module && module.videourl) {
    //   setVideoUrl(`https://d1x6q4m9kni4a2.cloudfront.net${module.videourl}`);
    // }
    if (module && module.videourl) {
      setVideoUrl(`${module.gumletid}`);
    }

  }, [module]); // This runs whenever the `module` prop changes

  return (
    <>
    
      <motion.div 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.5 }}
        className="container text-white"
      >
        {/* Video */}
        <div className="mb-8 w-full">
         
          {/* <TheosPlayer
        
    src={videoUrl}
    autoPlay={false}/> */}
   
   <div style={{ position: "relative", aspectRatio: "3/2" }}>
      <iframe
        loading="lazy"
        title="Gumlet video player"
        src={`https://play.gumlet.io/embed/${videoUrl}?preload=false&autoplay=false&loop=false&background=false&disable_player_controls=false`}
        style={{
          border: "none",
          position: "absolute",
          top: 0,
          left: 0,
          height: "100%",
          width: "100%",
        }}
        allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture; fullscreen"
      ></iframe>
    </div>
    
        </div>

        {/* Heading */}
        <motion.h1
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.5 }}
          className="text-4xl font-extrabold mb-4 text-indigo-400"
        >
          {module?.title}
        </motion.h1>

        {/* Description */}
        <p className="text-lg text-gray-400 mb-6">
          {module?.description}
        </p>

        {/* PDF Download */}
        {module?.resource && 
        <div className="mb-7">
          <a
            href={`${module?.resource}`}
            target="_blank"
            download
            className="inline-block px-6 py-3 bg-indigo-600 text-white font-semibold rounded-lg shadow-lg hover:bg-indigo-500 transition duration-300"
          >
            Resource
          </a>
        </div>
      }
      </motion.div>
    </>
  );
};

export default VideoSection;
